export default "__VITE_ASSET__B9GR5iW5__"